import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import authService from "../services/authService";
import AppLayout from "../components/AppLayout";
import Footer from "../components/Footer";

function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    // Remove token e dados do usuário
    authService.logout();
    // Redireciona para login
    navigate("/login");
  }, [navigate]);

  return (
    <AppLayout>
      <div className="auth-container">
        <h2>👋 Logout</h2>
        <p>Você foi desconectado. Redirecionando para login...</p>
      </div>
      <Footer />
    </AppLayout>
  );
}

export default Logout;
